/**
 * @generated SignedSource<<0704f39b738fa933ed39fa0d73b1f0fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useUserMembershipsRelayByIdQuery$variables = {
  id: string;
};
export type useUserMembershipsRelayByIdQuery$data = {
  readonly getUserMembership: {
    readonly adminCancellationReason: string | null | undefined;
    readonly approvedOn: any | null | undefined;
    readonly cancelationType: string | null | undefined;
    readonly canceledByAdmin: string | null | undefined;
    readonly canceledByAdminUser: {
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null | undefined;
    readonly canceledOn: any | null | undefined;
    readonly createdOn: any;
    readonly data: any | null | undefined;
    readonly dismissedOn: any | null | undefined;
    readonly email: string | null | undefined;
    readonly expiresOn: any | null | undefined;
    readonly failedRenewalAttempts: number | null | undefined;
    readonly freeRenewals: number;
    readonly id: string;
    readonly isActive: boolean | null | undefined;
    readonly isApproved: boolean | null | undefined;
    readonly isCanceled: boolean | null | undefined;
    readonly isExpired: boolean | null | undefined;
    readonly isPending: boolean | null | undefined;
    readonly isRejected: boolean | null | undefined;
    readonly lastCharged: any | null | undefined;
    readonly membership: {
      readonly activeOn: any | null | undefined;
      readonly archivedOn: any | null | undefined;
      readonly authExpiration: string | null | undefined;
      readonly authType: string | null | undefined;
      readonly brandingColor: string;
      readonly data: any | null | undefined;
      readonly id: string;
      readonly logoImageId: string | null | undefined;
      readonly name: string;
      readonly oldId: string | null | undefined;
      readonly perks: ReadonlyArray<{
        readonly discount: number | null | undefined;
        readonly freeTime: number | null | undefined;
        readonly id: string;
        readonly location: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly locationId: string | null | undefined;
        readonly moneyOff: number | null | undefined;
        readonly noFlex: boolean | null | undefined;
        readonly oldId: string | null | undefined;
        readonly system: {
          readonly currencyCode: string | null | undefined;
          readonly id: string;
          readonly mobilityType: number | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly systemOldId: string | null | undefined;
        readonly waiveBaseRate: boolean | null | undefined;
      }>;
      readonly prices: ReadonlyArray<{
        readonly autoRenews: boolean;
        readonly id: string;
        readonly minutes: number | null | undefined;
        readonly name: string | null | undefined;
        readonly price: number | null | undefined;
        readonly priority: number;
        readonly renewalInterval: string | null | undefined;
        readonly termEndsOn: any | null | undefined;
        readonly termStartsOn: any | null | undefined;
        readonly unlocks: number | null | undefined;
      }>;
    } | null | undefined;
    readonly membershipOldId: string;
    readonly membershipPrice: {
      readonly autoRenews: boolean;
      readonly id: string;
      readonly minutes: number | null | undefined;
      readonly name: string | null | undefined;
      readonly price: number | null | undefined;
      readonly priority: number;
      readonly renewalInterval: string | null | undefined;
      readonly termEndsOn: any | null | undefined;
      readonly termStartsOn: any | null | undefined;
      readonly unlocks: number | null | undefined;
    } | null | undefined;
    readonly membershipPriceId: string | null | undefined;
    readonly oldId: string | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly paidRenewals: number;
    readonly priority: number;
    readonly rejectedOn: any | null | undefined;
    readonly rejectionReason: string | null | undefined;
    readonly renewedDuration: string | null | undefined;
    readonly renewedTimes: number;
    readonly systemId: string | null | undefined;
    readonly user: {
      readonly email: string | null | undefined;
      readonly firstName: string;
      readonly fullName: string | null | undefined;
      readonly id: string;
      readonly lastName: string;
      readonly phone: string;
    } | null | undefined;
    readonly userId: string | null | undefined;
    readonly userOldId: string;
  } | null | undefined;
};
export type useUserMembershipsRelayByIdQuery = {
  response: useUserMembershipsRelayByIdQuery$data;
  variables: useUserMembershipsRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "data",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "price",
    "storageKey": null
  },
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "autoRenews",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "renewalInterval",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "termStartsOn",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "termEndsOn",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unlocks",
    "storageKey": null
  },
  (v8/*: any*/)
],
v10 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "UserMembership",
    "kind": "LinkedField",
    "name": "getUserMembership",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "approvedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canceledOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejectedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dismissedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isApproved",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCanceled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isExpired",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPending",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRejected",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "renewedTimes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "renewedDuration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paidRenewals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "freeRenewals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failedRenewalAttempts",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastCharged",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "membershipOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "membershipPriceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userOldId",
        "storageKey": null
      },
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejectionReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "adminCancellationReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cancelationType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canceledByAdmin",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUser",
        "kind": "LinkedField",
        "name": "canceledByAdminUser",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipPrice",
        "kind": "LinkedField",
        "name": "membershipPrice",
        "plural": false,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Membership",
        "kind": "LinkedField",
        "name": "membership",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authExpiration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activeOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archivedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandingColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoImageId",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Perk",
            "kind": "LinkedField",
            "name": "perks",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "freeTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "moneyOff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "waiveBaseRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "noFlex",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "systemOldId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "System",
                "kind": "LinkedField",
                "name": "system",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencyCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mobilityType",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Location",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MembershipPrice",
            "kind": "LinkedField",
            "name": "prices",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserMembershipsRelayByIdQuery",
    "selections": (v10/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUserMembershipsRelayByIdQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "fac71a5889986f78e8863aec5390cb8c",
    "id": null,
    "metadata": {},
    "name": "useUserMembershipsRelayByIdQuery",
    "operationKind": "query",
    "text": "query useUserMembershipsRelayByIdQuery(\n  $id: ID!\n) {\n  getUserMembership(id: $id) {\n    id\n    oldId\n    createdOn\n    approvedOn\n    canceledOn\n    expiresOn\n    rejectedOn\n    dismissedOn\n    isActive\n    isApproved\n    isCanceled\n    isExpired\n    isPending\n    isRejected\n    priority\n    renewedTimes\n    renewedDuration\n    paidRenewals\n    freeRenewals\n    failedRenewalAttempts\n    lastCharged\n    membershipOldId\n    membershipPriceId\n    systemId\n    organizationId\n    userId\n    userOldId\n    email\n    data\n    rejectionReason\n    adminCancellationReason\n    cancelationType\n    canceledByAdmin\n    canceledByAdminUser {\n      id\n      email\n      firstName\n      lastName\n    }\n    membershipPrice {\n      id\n      price\n      priority\n      autoRenews\n      renewalInterval\n      termStartsOn\n      termEndsOn\n      minutes\n      unlocks\n      name\n    }\n    user {\n      id\n      phone\n      firstName\n      lastName\n      fullName\n      email\n    }\n    membership {\n      id\n      oldId\n      name\n      authType\n      authExpiration\n      activeOn\n      archivedOn\n      brandingColor\n      logoImageId\n      data\n      perks {\n        id\n        oldId\n        freeTime\n        discount\n        moneyOff\n        waiveBaseRate\n        noFlex\n        systemOldId\n        locationId\n        system {\n          id\n          name\n          currencyCode\n          mobilityType\n        }\n        location {\n          id\n          name\n        }\n      }\n      prices {\n        id\n        price\n        priority\n        autoRenews\n        renewalInterval\n        termStartsOn\n        termEndsOn\n        minutes\n        unlocks\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "edb197657a0c31b50dbfcdad7ec04b57";

export default node;
